/**
 * DOM storage (local, session etc) field
 */
export class DOMStorageField {
  /**
   * @param {string}  key     storage key name
   * @param {Storage} storage reference to DOM storage
   */
  constructor(
    private key: string,
    private storage: Storage
  ) {}

  /** @return {string | null} value from storage or null if not exists */
  public get(): string | null {
    return this.storage.getItem(this.key);
  }

  /**
   * Set value in storage for key given in constructor
   * @param {string} value
   */
  public set(value: string): void {
    this.storage.setItem(this.key, value);
  }

  /**
   * Remove value from storage for key given in constructor
   */
  public remove(): void {
    this.storage.removeItem(this.key);
  }
}

/**
 * DOM storage map, where key is combination of base key, separator and field key
 */
export class DOMStorageMap {
  /**
   * @param {string}  baseKey storage key base
   * @param {Storage} storage reference to DOM storage
   * @param {string}  separator storage key separator
   */
  constructor(
    private baseKey: string,
    private storage: Storage,
    private separator = '_'
  ) {}

  /**
   * Full DOM storage key for field.
   * @param {string} fieldKey additional key, eg. userId, estateId
   */
  public storageKey(fieldKey: string): string {
    return `${this.baseKey}${this.separator}${fieldKey}`;
  }

  /**
   * Get value from storage under key {base}{separator}{field}
   * @param {string} fieldKey additional key, eg. userId, estateId
   * @return value from storage or null if not exists
   */
  public get(fieldKey: string): string | null {
    return this.storage.getItem(this.storageKey(fieldKey));
  }

  /**
   * Set value in storage for key {base}{separator}{field}
   * @param {string} fieldKey additional key, eg. userId, estateId
   * @param {string} value
   */
  public set(fieldKey: string, value: string): void {
    this.storage.setItem(this.storageKey(fieldKey), value);
  }

  /**
   * Remove value from storage under key {base}_{field}
   * @param {string} fieldKey additional key, eg. userId, estateId
   */
  public remove(fieldKey: string): void {
    this.storage.removeItem(this.storageKey(fieldKey));
  }
}
